import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DialogContainerDirective } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'rc-blank-layout',
  imports: [
    RouterOutlet,
    DialogContainerDirective,
  ],
  templateUrl: './blank-layout.component.html',
  styleUrl: './blank-layout.component.scss',
})
export class BlankLayoutComponent {

}
